var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoading)?_c('FullPageLoader'):_c('div',{staticStyle:{"position":"relative"}},[_c('app-navigation'),_vm._v(" "),(_vm.loading)?_c('loading-indicator',{staticClass:"my-5"}):_c('router-view'),_vm._v(" "),_c('inactivity-detection',{on:{"warn":_vm.warnInactive,"expired":_vm.inactive}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }